@if (dataArray.length>0) {
<table class="table table-bordered table-striped table-hover dataTable m-0 fixed-layout"
  ngClass="{{config.tableClass || ''}}" role="grid" style="width: 100%;">
  <thead class="grey lighten-2">
    <tr role="row">
      @for (column of _rowMetaArray; let i = $index; track column) {
      <th [class.hidden]="column.isHidden" (click)="changeSort(column)" ngClass="{{column.className || ''}}">
        {{column.description}}
        @if (column.isSortable) {
        <i class="ml-5 theme-text font-10 cursor-pointer" [ngClass]="column.sortCls"></i>
        }
        @if (config.hideAction && config.showTblSearch) {
        @if(config.showTblSearchAtStart && i == 0){
        <ng-component *ngTemplateOutlet="fnTableSeachRef"></ng-component>
        }
        @if(!config.showTblSearchAtStart && i == _rowMetaArraySize){
        <ng-component *ngTemplateOutlet="fnTableSeachRef"></ng-component>
        }
        }
      </th>
      }
      @if (!config.hideAction) {
      <th class="text-center relative width-10" style="min-width: 100px;">
        <span innerHTML="{{ 'Action(s)' | fnTranslate }}">
        </span>
        <ng-component *ngTemplateOutlet="fnTableSeachRef"></ng-component>
      </th>
      }
    </tr>
  </thead>
  <tbody>
    @for (row of dataCloneArray; track row) {
    <tr>
      @for (column of _rowMetaArray; let i = $index; track column) {
      <td (click)="cellClick(row, column.key)" [class.hidden]="column.isHidden" [ngClass]="{'rowExpand': ((config.showRowExpand) && (i < 1))}">
        @if (config.showRowExpand && i < 1) { 
          <i class="fn-global-expand expand-arrow"
          [ngClass]="{'rotate-180': row.isShowExpandDetail}" (click)="openRowExpand(row)"></i>
          }
          @switch (column.type) {
          @case ('number') {
          <div class="table-content" ngClass="{{column.rowDataClass || ''}}" title="{{row[column.key]}}">
            {{row[column.key]}} </div>
          }
          @case ('color') {
          <div class="table-content" ngClass="{{column.rowDataClass || ''}}" class="color-box padding-10 choppOff"
            [ngStyle]="{'background-color': row[column.key]}"></div>
          }
          @case ('boolean') {
          <div class="table-content" ngClass="{{column.rowDataClass || ''}}" class="color-box padding-10 choppOff">
            <fn-switch [(ngModel)]="row[column.key]" [name]="row[column.key]" [disabled]="true"> </fn-switch>
          </div>
          }
          @case ('innerHtml') {
          <div class="table-content" ngClass="{{column.rowDataClass || ''}}" title="{{row[column.key]}}"
            [innerHTML]="row[column.htmlTxtKey]">
          </div>
          }
          @case ('yn') {
          <div class="table-content" ngClass="{{column.rowDataClass || ''}}" class="color-box padding-10 choppOff">
            @if (row[column.key]) {
            Yes
            } @else{
            No
            }
          </div>
          }
          @default {
          <div class="table-content" ngClass="{{column.rowDataClass || ''}}" title="{{row[column.key]}}">
            {{row[column.key]}} </div>
          }
          }
      </td>
      }
      @if (!config.hideAction) {
      <td class="text-center width-10">
        @if (!config.hideEdit) {
        <button (click)="updateAction(row)" class="btn btn-link btn-action">
          <!-- <img src="assets/images/common/svg/edit-icon.svg" class="alta-table-btn"> -->
          <i ng-if="!config.hideEdit" class="hide fn-global-edit blue fa-lg font-20" title="Edit"></i>
        </button>
        }
        @if (!config.hideDelete) {
        <button (click)="deleteAction(row)" class="btn btn-link btn-action">
          <!-- <img src="assets/images/common/svg/delete-icon.svg" class="alta-table-btn"> -->
          <i ng-if="!config.hideDelete" class="hide fn-global-delete red fa-lg font-20" title="Delete"></i>
        </button>
        }
        @if (config.isCustomTemplate) {
        <ng-container [ngTemplateOutlet]="customTempRef" [ngTemplateOutletContext]="{$implicit: row}"></ng-container>
        }
        @if (config.isSelectable) {
        <input [(ngModel)]="row['isActive']" type="checkbox" (change)="updateAction(row)" style="opacity: 1">
        }
      </td>
      }
    </tr>
    @if(config.showRowExpand && row.isShowExpandDetail){
    @for (innerRow of row[config.rowExpandName]; track innerRow) {
    <tr>
      @for (column of _rowMetaArray; let i = $index; track column) {
      <td (click)="cellClick(innerRow, column.key)" [class.hidden]="column.isHidden">
        @switch (column.type) {
        @case ('number') {
        <div class="table-content" ngClass="{{column.rowDataClass || ''}}" title="{{innerRow[column.key]}}">
          {{innerRow[column.key]}} </div>
        }
        @case ('color') {
        <div class="table-content" ngClass="{{column.rowDataClass || ''}}" class="color-box padding-10 choppOff"
          [ngStyle]="{'background-color': innerRow[column.key]}"></div>
        }
        @case ('boolean') {
        <div class="table-content" ngClass="{{column.rowDataClass || ''}}" class="color-box padding-10 choppOff">
          <fn-switch [(ngModel)]="innerRow[column.key]" [name]="innerRow[column.key]" [disabled]="true"> </fn-switch>
        </div>
        }
        @case ('innerHtml') {
        <div class="table-content" ngClass="{{column.rowDataClass || ''}}" title="{{innerRow[column.key]}}"
          [innerHTML]="innerRow[column.htmlTxtKey]">
        </div>
        }
        @case ('yn') {
        <div class="table-content" ngClass="{{column.rowDataClass || ''}}" class="color-box padding-10 choppOff">
          @if (innerRow[column.key]) {
          Yes
          } @else{
          No
          }
        </div>
        }
        @default {
        <div class="table-content" ngClass="{{column.rowDataClass || ''}}" title="{{innerRow[column.key]}}">
          {{innerRow[column.key]}} </div>
        }
        }
        }
        @if (!config.hideAction) {
      <td class="text-center width-10">
        @if (!config.hideEdit) {
        <button (click)="updateAction(row)" class="btn btn-link btn-action">
          <!-- <img src="assets/images/common/svg/edit-icon.svg" class="alta-table-btn"> -->
          <i ng-if="!config.hideEdit" class="hide fn-global-edit blue fa-lg font-20" title="Edit"></i>
        </button>
        }
        @if (!config.hideDelete) {
        <button (click)="deleteAction(row)" class="btn btn-link btn-action">
          <!-- <img src="assets/images/common/svg/delete-icon.svg" class="alta-table-btn"> -->
          <i ng-if="!config.hideDelete" class="hide fn-global-delete red fa-lg font-20" title="Delete"></i>
        </button>
        }
        @if (config.isCustomTemplate) {
        <ng-container [ngTemplateOutlet]="customTempRef" [ngTemplateOutletContext]="{$implicit: row}"></ng-container>
        }
        @if (config.isSelectable) {
        <input [(ngModel)]="row['isActive']" type="checkbox" (change)="updateAction(row)" style="opacity: 1">
        }
      </td>
      }
    </tr>
    }
    }
    }
  </tbody>
  @if (footerRowObj && dataCloneArray.length>0) {
  <tfoot>
    <tr ngClass="{{footerclass || ''}}">
      @for(column of _rowMetaArray; let i = $index; track column) {
      @if(column.isShowFooter){
      <th [class.hidden]="column.isHidden" ngClass="{{column.rowDataClass || ''}}">{{footerRowObj[column.key]}}</th>
      }@else{
      <th></th>
      }
      }
      @if(!config.hideAction){
      <th></th>
      }
    </tr>
  </tfoot>
  }
</table>
}
@if(dataCloneArray.length<1){ <div class="no_data_display"><span
    innerHTML="{{ 'No_Data_to_display' | fnTranslate }}"></span></div>
  }
  <fn-pagination [currentPage]="currentPage" [totalPage]="totalPage" (changePage)="paginzationEvent($event)">
  </fn-pagination>

  <!-- table search ref -->
  <ng-template #fnTableSeachRef>
    <label class="label cursor-pointer align-middle mb-0 ml-5" (click)="toggleSearch($event)">
      <i class="fn-global-search float-right blue theme-text font-10"></i>
    </label>
    @if (showSearchBox) {
    <fn-table-search (search)="searchOnRows($event)" [config]="tblSearchConfig"
      [tblSearchClass]="config.tableSearchClass" (closeSearch)="closeSearch($event)">
    </fn-table-search>
    }
  </ng-template>
